import { render, staticRenderFns } from "./aidaStudentList.vue?vue&type=template&id=71b4eede&"
import script from "./aidaStudentList.vue?vue&type=script&lang=js&"
export * from "./aidaStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports